var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label required" }, [
              _vm._v(_vm._s(_vm.t("application.contact_mobile"))),
            ]),
            _vm._v(" "),
            _c("MobileInput", {
              attrs: {
                fieldTitle: _vm.t("application.contact_mobile", {}, "zh"),
                fieldname: "mobile",
                fieldType: "mobile",
                "field-attrs": "unique",
                name: "mobile",
                maxlength: "8",
                minlength: "8",
                required: "",
                value: _vm.$store.state.form.applicantInfo.mobile
                  ? _vm.$store.state.form.applicantInfo.mobile.replace(
                      "+852",
                      ""
                    )
                  : "",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-8 col-xs-12" }, [
          _c("div", { staticClass: "row files" }, [
            _c("label", { staticClass: "col-8 col-xs-6 col-form-label" }, [
              _c("span", [_vm._v(_vm._s(_vm.t("application.br")))]),
              _vm._v(" "),
              _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-4 col-xs-6 text-right" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  fieldTitle: _vm.t("application.br", {}, "zh"),
                  fieldname: "br",
                  name: "br",
                  type: "file",
                  required: "",
                  accept: "image/*,.pdf",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn btn-secondary", attrs: { type: "button" } },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.t("form.upload_file")) +
                      "\n            "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "selected-files" }),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-8 col-xs-12" }, [
          _c("div", { staticClass: "row files multiple" }, [
            _c("label", { staticClass: "col-8 col-xs-7 col-form-label" }, [
              _c("span", [_vm._v(_vm._s(_vm.t("application.bank_statement")))]),
              _vm._v(" "),
              _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-4 col-xs-5 text-right" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  fieldTitle: _vm.t("application.bank_statement", {}, "zh"),
                  fieldname: "statementSoftCopy",
                  name: "statement",
                  type: "file",
                  multiple: "",
                  accept: "image/*,.pdf",
                  required: "",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn btn-secondary", attrs: { type: "button" } },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.t("form.upload_file")) +
                      "\n            "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "selected-files" }),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-8 col-xs-12" }, [
          _c("div", { staticClass: "row files multiple" }, [
            _c(
              "label",
              { staticClass: "col-9 col-sm-7 col-xs-7 col-form-label pr-0" },
              [_c("span", [_vm._v(_vm._s(_vm.t("application.pos_statement")))])]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-3 col-sm-5 col-xs-5 text-right" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  fieldTitle: _vm.t("application.pos_statement", {}, "zh"),
                  fieldname: "PosStatementSoftCopy",
                  name: "pos_statement",
                  type: "file",
                  multiple: "",
                  accept: "image/*,.pdf",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn btn-secondary", attrs: { type: "button" } },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.t("form.upload_file")) +
                      "\n            "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "selected-files" }),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-8 col-xs-12" }, [
          _c("div", { staticClass: "row files multiple" }, [
            _c(
              "label",
              { staticClass: "col-9 col-sm-7 col-xs-7 col-form-label pr-0" },
              [_c("span", [_vm._v(_vm._s(_vm.t("application.annual_report")))])]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-3 col-sm-5 col-xs-5 text-right" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  fieldTitle: _vm.t("application.annual_report", {}, "zh"),
                  fieldname: "AnnualReportSoftCopy",
                  name: "annual_report",
                  type: "file",
                  multiple: "",
                  accept: "image/*,.pdf",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn btn-secondary", attrs: { type: "button" } },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.t("form.upload_file")) +
                      "\n            "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "selected-files" }),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "form-group",
        staticStyle: {
          "max-height": "300px",
          "overflow-y": "auto",
          padding: "10px 0px",
        },
      },
      [
        _c("small", {
          domProps: {
            innerHTML: _vm._s(
              _vm.t("application.terms", { companyName: _vm.companyName })
            ),
          },
        }),
        _vm._v(" "),
        _vm.checkTu
          ? _c("small", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.t("application.tu_terms", {
                    companyName: _vm.companyName,
                  })
                ),
              },
            })
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-group text-right col-xs-12" }, [
      _c("label", { staticClass: "col-form-label" }, [
        _vm._v(_vm._s(_vm.t("application.agree_terms")) + "\n      "),
        _c("input", {
          attrs: {
            type: "checkbox",
            name: "terms",
            value: "agree",
            required: "",
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }